import { LoginLayout as Layout } from '../../../layouts/Login/LoginLayout';
import { LoginForm } from '../LoginForm/LoginForm';

export const LoginPage = () => {
  return (
    <Layout>
      <LoginForm />
    </Layout>
  );
};
